import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ICreateNoteRequest, INote, INoteDetailsResponse, IUpdateNoteRequest } from '../models/note';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';

@Injectable({
  providedIn: 'root'
})
export class DeviceNoteService {

    constructor(private http: HttpClient) { }

    createDeviceNote(request: ICreateNoteRequest) {
        return this.http.post<INoteDetailsResponse>(
            `${environment.baseUrl}/v1/notes/createNote`,
            request
        )
    }

    getNoteById(id: string){
        return this.http.get<INoteDetailsResponse>(
          `${environment.baseUrl}/v1/notes/getNote/${id}`
        )
    }

    getDeviceNotesByDevice(id: string){
        return this.http.get<IPagedResults<INoteDetailsResponse[]>>(
            `${environment.baseUrl}/v1/notes/searchNotesByDevice/${id}`,
        )
    }

    updateDeviceNote(request: IUpdateNoteRequest){
        return this.http.put<INoteDetailsResponse>(
            `${environment.baseUrl}/v1/notes/updateNote/${request.id}`,
            request
        )
    }

    deleteDeviceNote(id :string){
        return this.http.delete(
            `${environment.baseUrl}/v1/notes/deleteNote/${id}`
        )
    }
}